
export const pageMetadata: { [key: string]: { title: string, description: string } } = {
  "/home": {
    title: "Carolina Trophy Roofs | #1 Roofing Contractor in Rocky Mount, NC",
    description: "Carolina Trophy Roofs is the top-rated roofing contractor serving Rocky Mount, NC and Eastern North Carolina. Expert residential & commercial roofing services, storm damage restoration, and insurance claims assistance. Call (252) 302-2003 for free estimates."
  },
  "/services": {
    title: "Professional Roofing Services | Carolina Trophy Roofs | Eastern NC",
    description: "Comprehensive roofing services in Eastern NC: roof replacement, repair, inspection, storm damage restoration, commercial & residential roofing. Licensed, insured, and locally trusted since 2010."
  },
  "/brands": {
    title: "Top Roofing Material Brands | Carolina Trophy Roofs | Quality Materials",
    description: "Carolina Trophy Roofs partners with premium roofing manufacturers: GAF, Owens Corning, CertainTeed, and more. Quality materials with comprehensive warranties for Eastern NC homes and businesses."
  },
  "/locations": {
    title: "Service Areas | Carolina Trophy Roofs | Eastern North Carolina Coverage",
    description: "Carolina Trophy Roofs serves Rocky Mount, Greenville, Wilson, Tarboro, Zebulon and throughout Eastern NC. Local roofing contractors with offices in Rocky Mount and Greenville."
  },
  "/locations/rockymount-nc": {
    title: "Rocky Mount, NC Roofing Contractor | Carolina Trophy Roofs",
    description: "Professional roofing services in Rocky Mount, NC. Local roofing contractor specializing in residential & commercial roofing, storm damage, and insurance claims. Call (252) 302-2003."
  },
  "/locations/greenville-nc": {
    title: "Greenville, NC Roofing Contractor | Carolina Trophy Roofs", 
    description: "Expert roofing services in Greenville, NC and surrounding areas. Residential & commercial roofing, storm damage restoration, free estimates. Call our Greenville office: (252) 371-2266."
  },
  "/gallery": {
    title: "Roofing Project Gallery | Carolina Trophy Roofs | Before & After Photos",
    description: "View our completed roofing projects in Rocky Mount, Greenville, and Eastern NC. See quality craftsmanship, material options, and customer transformations in our photo gallery."
  },
  "/blog": {
    title: "Roofing Tips & Expert Advice | Carolina Trophy Roofs Blog | Eastern NC",
    description: "Get expert roofing advice, maintenance tips, industry insights, and local Eastern NC roofing news from Carolina Trophy Roofs. Professional guidance for homeowners and businesses."
  },
  "/resources": {
    title: "Roofing Resources & Guides | Carolina Trophy Roofs | Eastern NC",
    description: "Comprehensive roofing resources: material guides, maintenance tips, warranty information, insurance claim help, and expert advice from Eastern NC's trusted roofing contractors."
  },
  "/resources/identify-roof-damage": {
    title: "How to Identify Roof Damage | Expert Guide | Carolina Trophy Roofs",
    description: "Learn to spot roof damage signs early with expert tips from Carolina Trophy Roofs. Protect your Eastern NC home with professional damage identification guide. Free inspections available."
  },
  "/about": {
    title: "About Carolina Trophy Roofs | Eastern NC's Trusted Roofing Contractor",
    description: "Learn about Carolina Trophy Roofs: Eastern NC's premier roofing contractor since 2010. Locally owned, licensed, insured, and committed to quality craftsmanship and customer satisfaction."
  },
  "/contact": {
    title: "Contact Carolina Trophy Roofs | Free Roofing Estimates | Eastern NC",
    description: "Contact Carolina Trophy Roofs for free roofing estimates in Eastern NC. Rocky Mount: (252) 302-2003, Greenville: (252) 371-2266. Emergency repairs, insurance claims, all roofing services."
  },
  "/privacy": {
    title: "Privacy Policy | Carolina Trophy Roofs | Data Protection",
    description: "Carolina Trophy Roofs privacy policy: how we collect, use, and protect your personal information. Transparent data practices for our Eastern NC roofing customers."
  },
  "/sms-terms": {
    title: "SMS Terms & Conditions | Carolina Trophy Roofs | Text Messaging",
    description: "SMS terms and conditions for Carolina Trophy Roofs text messaging services. Opt-in/opt-out procedures, messaging rates, and service details for Eastern NC customers."
  },
  "/sitemap": {
    title: "Sitemap | Carolina Trophy Roofs | Complete Site Navigation",
    description: "Complete sitemap for Carolina Trophy Roofs website. Navigate all pages, blog posts, service locations, and resources for Eastern NC roofing services and information."
  },
  "/specialty-services/church-steeple-repair": {
    title: "Church Steeple Repair | Historic Restoration | Carolina Trophy Roofs",
    description: "Expert church steeple repair and historic restoration in Eastern NC. Specialized craftsmanship for religious buildings, traditional techniques, modern materials. Free consultations."
  },
  "/specialty-services/roof-coating": {
    title: "Roof Coating Services | Protective Applications | Carolina Trophy Roofs",
    description: "Professional roof coating services in Eastern NC. Extend roof life, improve energy efficiency, and protect against weather. Commercial and residential applications available."
  },
  "/professional-church-steeple-repair-and-replacement-services-in-raleigh-nc-and-surrounding-areas": {
    title: "Professional Church Steeple Repair and Replacement Services in Raleigh NC and Surrounding Areas | Carolina Trophy Roofs",
    description: "Expert church steeple repair and replacement services in Raleigh, NC and surrounding areas. Professional steeple restoration, maintenance, and emergency repairs. Licensed contractors serving churches throughout the Triangle area."
  }
};
